import React, { Fragment } from 'react'
import {
  StyleTalkToSupportRightContentWrapper,
  StyleTalkToSupportWrapper,
  TextWrapper,
} from './style'
import {
  InstantConsultationIcon,
  OverLappingImageSvg,
  TalkToSupportIcon,
} from '@pages/front/svgs/svg'
import { StyleContentWrapper } from '@pages/front/commons/ContentWrapper/style'
import { StyleText } from '@pages/front/commons/Text/style'
import { TextWrapperAlternate } from '@pages/front/commons/Text'
import { StyleSvgWrappeer } from '@pages/front/commons/SvgIcon/style'
import Button from '@components/button'

const TalkToSupportBanner = () => {
  return (
    <StyleContentWrapper stretch paddingLeft="45" paddingRight="45">
      <StyleTalkToSupportWrapper>
        <StyleTalkToSupportRightContentWrapper>
          <StyleSvgWrappeer
            translateY="12px"
            dangerouslySetInnerHTML={{ __html: OverLappingImageSvg }}
          />
          <TextWrapper>
            <StyleText fontSize="18" centered>
              Need Help With Booking Your Consultation ?
            </StyleText>
            <StyleText weight="400" centered>
              Our Experts are here to Help You.
            </StyleText>
          </TextWrapper>
        </StyleTalkToSupportRightContentWrapper>

        <Button title="Talk To Support" icon={TalkToSupportIcon} />
      </StyleTalkToSupportWrapper>
    </StyleContentWrapper>
  )
}

export default TalkToSupportBanner
